module.exports = __webpack_public_path__ + "media/images/icons/school-achievement-8ea4d182f570e176111f8f6449671012.svg";